const getTimelineViewSettings = state => state.definitions.timelineViewSettings;

const getTimelineShowRelationshipTypeIds = state => state.definitions.timelineViewSettings.showRelationshipTypes;

export default {
  getTimelineViewSettings,
  getTimelineShowRelationshipTypeIds
};
